import React from 'react'
import styled from "styled-components";
import Modal from "styled-react-modal";
import { useState } from 'react';
import { TextContainer } from '../../styles/globalStyles';
import {CloseOutline as Close} from '@styled-icons/evaicons-outline/CloseOutline'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { updateUserLoc } from '../../redux/feature/authSlice';
import { useDispatch } from 'react-redux';
import { getUserInfo } from '../../redux/feature/authSlice';

const options = ["Coimbatore","Mumbai"];

function MyLocation() {  
    const navigate = useNavigate()
    const auth=useSelector((state) => state.auth)
    const dispatch=useDispatch()
    const [isOpen, setIsOpen] = useState(true);
    const [opacity, setOpacity] = useState(0);
  
    function toggleModal(e) {
      setOpacity(0);
      setIsOpen(!isOpen);      
    }
  
    function afterOpen() {
      setTimeout(() => {
        setOpacity(1);
      }, 100);
    }
  
    function beforeClose() {
      return new Promise((resolve) => {
        setOpacity(0);
        setTimeout(resolve, 300);
      });
    }

  const [isDropOpen, setIsDropOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(auth.creds.userlocation === '' ? "Mumbai" : auth.creds.userlocation);

  const toggling = () => setIsDropOpen(!isDropOpen);

  const onOptionClicked = value => () => {
    setSelectedOption(value);
    setIsDropOpen(false);
  };

  return (  
      <StyledModal
        isOpen={isOpen}
        afterOpen={afterOpen}
        beforeClose={beforeClose}
        opacity={opacity}
        backgroundProps={{ opacity }}
      >
        <MainContainer>
        <Header>
           <HeaderText>Hi {auth.creds.username.split(' ')[0]}, Select your Location</HeaderText> 
            <CloseButton onClick={()=>{toggleModal(); navigate('/')}} disabled={auth.creds.userlocation === '' ? true : false}>
              <Close size={20} />
            </CloseButton>
        </Header>
        <BodyContainer>
        <BodyTitle>Please select your preferred location</BodyTitle>
      <DropDownContainer>
        <DropDownHeader onClick={toggling}>
          {selectedOption || "Mumbai"}
        </DropDownHeader>
        {isDropOpen && (
          <DropDownListContainer>
            <DropDownList>
              {options.map(option => (
                <ListItem onClick={onOptionClicked(option)} key={Math.random()}>
                  {option}
                </ListItem>
              ))}
            </DropDownList>
          </DropDownListContainer>
        )}
      </DropDownContainer>
                <SubmitButton onClick={()=>{
                dispatch(updateUserLoc(selectedOption))
                toggleModal()
                navigate('/')
                }}>Save Location</SubmitButton>
        </BodyContainer>
        </MainContainer>
      </StyledModal>
  )
}

export default MyLocation

const StyledModal = Modal.styled`
    width: 32rem;
    max-width: calc(100vw - 2rem);
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    opacity: ${(props) => props.opacity};
    transition: all 0.3s ease-in-out;
    border-radius: 16px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
    overflow: hidden;
`;

const MainContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

const Header = styled.div`
    width: 100%;
    background: linear-gradient(135deg, #F7707D 0%, #F29173 100%);
    display: flex;
    justify-content: space-between;
    padding: 1.4rem 2rem;
    align-items: center;
`;

const HeaderText = styled.span`
    color: white;
    font-size: 1.3rem;
    font-weight: 600;
`;

const CloseButton = styled.button`
    background: none;
    border: none;
    color: rgba(255,255,255,0.8);
    cursor: pointer;
    padding: 10px;
    border-radius: 8px;
    transition: all 0.15s;
    min-width: 40px;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    -webkit-tap-highlight-color: transparent;
    
    &:hover, &:active {
        color: white;
        background: rgba(255,255,255,0.15);
    }
    
    &:disabled {
        opacity: 0.3;
        cursor: not-allowed;
    }
`;

const BodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2.4rem 2rem;
`;

const BodyTitle = styled.h3`
    font-size: 1.5rem;
    font-weight: 600;
    color: #1e1e2d;
    margin-bottom: 1.5rem;
    text-align: center;
`;

const DropDownContainer = styled.div`
    width: 100%;
    max-width: 200px;
    margin: 0 auto 1.5rem;
    position: relative;
`;

const DropDownHeader = styled.div`
    padding: 0.8rem 1.4rem;
    background: #f4f4f5;
    border: 1.5px solid #e4e4e7;
    border-radius: 10px;
    font-weight: 600;
    font-size: 1.35rem;
    color: #1e1e2d;
    cursor: pointer;
    text-align: center;
    transition: border-color 0.2s;

    &:hover {
        border-color: #F7707D;
    }
`;

const DropDownListContainer = styled.div`
    position: absolute;
    z-index: 100;
    width: 100%;
    left: 0;
    margin-top: 4px;
`;

const DropDownList = styled.ul`
    padding: 0.5rem 0;
    margin: 0;
    background: #ffffff;
    border: 1.5px solid #e4e4e7;
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    list-style: none;
`;

const ListItem = styled.li`
    padding: 0.7rem 1.4rem;
    font-size: 1.3rem;
    font-weight: 500;
    color: #1e1e2d;
    cursor: pointer;
    transition: background 0.15s;

    &:hover {
        background: #f4f4f5;
        color: #F7707D;
    }
`;

const SubmitButton = styled.button`
    background: linear-gradient(135deg, #F7707D 0%, #F29173 100%);
    padding: 1rem 3rem;
    min-height: 44px;
    border-radius: 10px;
    border: none;
    color: white;
    font-size: 1.35rem;
    font-weight: 700;
    cursor: pointer;
    font-family: 'Nunito Sans', sans-serif;
    transition: all 0.2s ease;
    -webkit-tap-highlight-color: transparent;

    &:hover, &:active {
        transform: translateY(-1px);
        box-shadow: 0 6px 16px rgba(247, 112, 125, 0.3);
    }

    &:active {
        transform: translateY(0);
    }
`;
